'use strict';

/**
 * AskAPI: the one custom call the user-facing Ask area needs -- filing a Request against a Task (V50 User
 * Tasks). Everything else the Ask view reads (the Active task catalog, a task's prompt shape, a person's own
 * requests, a single request's live status and answer) rides the generic EntityAPI providers that the
 * descriptor loop already creates: TaskAPI, PromptShapeAPI, RequestAPI. Only the submit is bespoke, because it
 * is not a create -- the server assembles the shape, mints the Request AND a hub-dispatch Run, and links them.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'AskAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderAskAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	// POST /1.0/Request/Submit { IDTask, InputValues, Name?, Attachments? }. InputValues is keyed by the task's
	// prompt-shape segment Keys (a single free-text ask sends { body: '<text>' }). Attachments is an optional list
	// of { Source:'media', Ref:<IDMedia>, Name, ContentType, Size } references for a conversational task. Resolves
	// to { Success, IDRequest, RequestNumber, IDRun, Status, Conversational?, IDAssistantMessage? }.
	submitRequest(pIDTask, pInputValues, pName, pAttachments, pIDProject)
	{
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'Request/Submit',
		{
			IDTask: Number(pIDTask) || 0,
			InputValues: (pInputValues && typeof pInputValues === 'object') ? pInputValues : {},
			Name: pName || '',
			Attachments: Array.isArray(pAttachments) ? pAttachments : [],
			IDProject: Number(pIDProject) || 0
		});
	}

	// POST /1.0/Request/:id/Message { Content, Attachments? } -- add a turn to a conversational Request. Resolves
	// to { Success, IDRequest, IDUserMessage, IDAssistantMessage, IDRun, Status }.
	postMessage(pIDRequest, pContent, pAttachments)
	{
		return libFrameworkClient.postJSON(this.fable, this.routePrefix + 'Request/' + (Number(pIDRequest) || 0) + '/Message',
		{
			Content: String(pContent || ''),
			Attachments: Array.isArray(pAttachments) ? pAttachments : []
		});
	}
}

module.exports = PictProviderAskAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
